export default "/profile/images/human-stand.svg?0eb403a025f2340ba7b61223c5a243ed";